import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchTripsByCategory } from '../../functions/FetchTrips';
import '../../styles/homeCategories.css';
import { db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';

const BackpackTrips = () => {
  const cardsContainerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [backpackTrips, setBackpackTrips] = useState([]);
  const [bannerImage, setBannerImage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  useEffect(() => {
    const fetchBackpackTrips = async () => {
      const trips = await fetchTripsByCategory('backpack');
      setBackpackTrips(trips);
    };
    fetchBackpackTrips();
  }, []);

  useEffect(() => {
    async function fetchBannerImage() {
      try {
        const docRef = doc(db, "Images", "AllImages");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data()["Backpack Trips"] && docSnap.data()["Backpack Trips"].url) {
          setBannerImage(docSnap.data()["Backpack Trips"].url);
        }
      } catch (error) {
        // fallback: do nothing
      }
    }
    fetchBannerImage();
  }, []);

  const scrollLeft = () => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollLeft -= 250;
    }
  };

  const scrollRight = () => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollLeft += 250;
    }
  };

  const handleCardClick = (tripId) => {
    window.scrollTo(0, 0);
    navigate(`/itinerary/${tripId}`);
  };

  return (
    <div className="category-outer-container">
      <div className="category-container">
        <div
          className="category-banner"
          style={{
            backgroundImage: bannerImage
              ? `url('${bannerImage}')`
              : "url('https://images.unsplash.com/photo-1501554728187-ce583db33af7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80')"
          }}
        >
          <div className="category-banner-content">
            <h1 className="category-banner-h1" style={{ fontSize: isMobile ? '1.8em' : '2.5em' }}>Backpack Trips</h1>
            <p className="category-banner-p">Discover trails, campsites, and budget-friendly tours</p>
            <button
              type="button"
              className="category-explore-button"
              style={{ backgroundColor: '#ffeb3b', color: '#111' }}
              onClick={() => {
                navigate('/destinations?location=backpacking');
                window.scrollTo(0, 0);
              }}
            >
              Explore
            </button>
          </div>
        </div>
      </div>

      <button
        className="nav-arrow nav-left"
        onClick={scrollLeft}
        aria-label="Scroll left"
      >
        <span className="arrow-icon" style={{ backgroundColor: '#FFD700' }}>
          <i className="fas fa-chevron-left"></i>
        </span>
      </button>

      <button
        className="nav-arrow nav-right"
        onClick={scrollRight}
        aria-label="Scroll right"
      >
        <span className="arrow-icon" style={{ backgroundColor: '#FFD700' }}>
          <i className="fas fa-chevron-right"></i>
        </span>
      </button>

      <div className="category-cards-overlay" ref={cardsContainerRef}>
        {backpackTrips.map((destination, index) => (
          <div
            key={index}
            className="destination-card"
            onClick={() => handleCardClick(destination.id)}
            role="button"
            tabIndex={0}
          >
            <img 
              src={destination.cover_image_url || null} 
              alt={destination.location || destination.name} 
              className="destination-card-img" 
            />
            <div className="card-info">
              <h3 className="card-info-h3">{destination.tripname || destination.location}</h3>
              {/* <p className="card-info-p">Starts From {destination.display_price}/-</p> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BackpackTrips;
